import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header, Condition, General } from "../../components";
import {
  CreateMessageSuppressionContainer,
  TabsContainer,
} from "./CreateMessageSuppression.styled";
import Tabs2 from "../../../../../elements/v2/Tabs2/Tabs2";

const tabsEnum = {
  CONDITIONS: 0,
  GENERAL: 1,
};

const tabs = [{ label: "Conditions" }, { label: "General" }];

const CreateMessageSuppression = () => {
  const [activeTab, setActiveTab] = useState(tabsEnum.CONDITIONS);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/v2/suppression-rules");
  };

  const handleNavigateToList = () => {
    navigate("/v2/suppression-rules/list");
  };

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <CreateMessageSuppressionContainer>
      <Header
        title="Create a Rule for Message Suppression"
        description="Avoid over-messaging by limiting how often contacts receive communications."
        onBack={handleBack}
      />
      <TabsContainer>
        <Tabs2
          activeIndex={activeTab}
          defaultIndex={activeTab}
          tabs={tabs}
          onToggleTab={handleTabChange}
        />
      </TabsContainer>
      <Tabs2.Outlet show={activeTab === tabsEnum.CONDITIONS}>
        <Condition
          onNext={() => {
            handleTabChange(tabsEnum.GENERAL);
          }}
        />
      </Tabs2.Outlet>
      <Tabs2.Outlet show={activeTab === tabsEnum.GENERAL}>
        <General onNext={handleNavigateToList} />
      </Tabs2.Outlet>
    </CreateMessageSuppressionContainer>
  );
};

export default CreateMessageSuppression;
